// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"524":"37b62f45e23ce655","1060":"23fb9b92ac696121","2567":"58a98e561c5c2a22","2585":"d0aa338edf06872b","4007":"690ac60cadf899d2","4342":"598ec7c49ac552ba","4349":"edf8b0af55185fc2","5381":"9f17b69418b6244a","6916":"dc26d435271f6fa0","9774":"71abaa79c075fd66","9793":"6d10c70c6882c28d"}[chunkId] + ".css";
};